import clsx from 'clsx';
import DataTablePageSizeSelectBox from '../atoms/DataTablePageSizeSelectBox';
import DataTablePagination from '../atoms/DataTablePagination';
import type { IDataTableClassNames, IDataTablePaginationComponentCommonProps, IDataTableProps } from '../shared/types';

/**
 * DataTableFooter component'inin props interface'i.
 * Pagination ve page size select box'ı bir arada gösterir.
 */
export interface IDataTableFooterProps extends IDataTablePaginationComponentCommonProps, Pick<IDataTableProps<any, any>, 'paginationProps' | 'pageSizeProps'> {
  /**
   * Footer bölümlerine özel CSS sınıfları.
   * - footer: Ana footer wrapper div'i
   * - paginationWrapper: Pagination component'inin wrapper'ı
   * - pageSizeWrapper: Page size select box'ın wrapper'ı
   */
  classNames?: Pick<IDataTableClassNames, 'footer' | 'paginationWrapper' | 'pageSizeWrapper'>;
}

/**
 * DataTableFooter Component
 *
 * Tablonun alt kısmında pagination ve sayfa boyutu seçiciyi gösterir.
 * Bu component, DataTableInner tarafından otomatik olarak render edilir.
 *
 * Layout:
 * - Sol tarafta: Pagination (sayfa numaraları, önceki/sonraki butonları)
 * - Sağ tarafta: Page size select box (10, 20, 50, 100 gibi seçenekler)
 *
 * @param props - Footer props'ları
 * @param props.setPagination - Pagination durumunu güncelleme fonksiyonu
 * @param props.paginationState - Mevcut pagination durumu (pageIndex, pageSize)
 * @param props.paginationMeta - Pagination meta bilgileri (itemCount, pageCount)
 * @param props.paginationProps - Pagination component'ine özel props
 * @param props.pageSizeProps - Page size select box'a özel props
 * @param props.classNames - Özelleştirilebilir CSS sınıfları
 *
 * @returns JSX.Element - Footer UI'ı
 */
export default function DataTableFooter(props: IDataTableFooterProps) {
  const { paginationProps, pageSizeProps, setPagination, paginationState, paginationMeta, classNames } = props;

  const { footer: footerClassName, paginationWrapper: paginationWrapperClassName, pageSizeWrapper: pageSizeWrapperClassName } = classNames || {};

  return (
    <div className={clsx('col d-lg-flex justify-content-end align-items-center mt-5 gap-4', footerClassName)}>
      <div className={clsx('d-flex justify-content-end position-relative', paginationWrapperClassName)}>
        <DataTablePagination {...paginationProps} setPagination={setPagination} paginationState={paginationState} paginationMeta={paginationMeta} />
      </div>
      <div className={clsx('d-flex justify-content-center align-items-center', pageSizeWrapperClassName)}>
        <DataTablePageSizeSelectBox {...pageSizeProps} setPagination={setPagination} paginationState={paginationState} paginationMeta={paginationMeta} />
      </div>
    </div>
  );
}
